import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';


export type CountryTaxType = {
  periodName: string,
  countryTaxType: string,
  countryCode: string,
  description: string,
  taxRate: number,
  defTaxRate: number,
  taxCurrency: string,
}

export const useCountryTaxTypesList = (
  { periodName }: { periodName: string },
  { enabled = true }: { enabled?: boolean } = {}
) => useCustomQuery<CountryTaxType[]>(
  [
    QueryKeys.countryTaxTypes.CountryTaxTypesList],
  {
    url: Config.endpoints.FETCH_COUNTRY_TAX_TYPES_FOR_OBLIGATIONS
      .replace(/:periodName/, String(periodName)),
    errorMessage: 'Fetching country tax types options',
    enabled,
    defaultData: [],
  });
